module.exports = __webpack_public_path__ + "static/media/settings-notifications.75b15b57.png";